export default __webpack_public_path__ + "static/media/slide01.5930a982.jpg";